module.exports = __webpack_public_path__ + "img/card_2_ref_3.32039e6a.jpg";